"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VOrgChart = void 0;
var react_1 = __importStar(require("react"));
var jquery_1 = __importDefault(require("jquery"));
require("orgchart/src/css/jquery.orgchart.css");
var styles_1 = require("./styles");
var react_dom_1 = __importDefault(require("react-dom"));
require('orgchart/src/js/jquery.orgchart.js');
var VOrgChart = function (_a) {
    var idContainer = _a.idContainer, Custom = _a.customTemplate, nodeTemplate = _a.nodeTemplate, lineWidth = _a.lineWidth, lineColor = _a.lineColor, onRender = _a.onRender, initCompleted = _a.initCompleted, options = __rest(_a, ["idContainer", "customTemplate", "nodeTemplate", "lineWidth", "lineColor", "onRender", "initCompleted"]);
    var containerRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        var chart = (0, jquery_1.default)(containerRef.current).orgchart(__assign({ nodeTemplate: Custom
                ? function (data) {
                    var div = document.createElement('div');
                    react_dom_1.default.render(react_1.default.createElement(Custom, __assign({}, { data: data })), div);
                    return div;
                }
                : nodeTemplate, initCompleted: function ($chart) {
                initCompleted && initCompleted($chart);
                onRender && onRender(chart);
            } }, options));
        return function () {
            (0, jquery_1.default)(containerRef.current).empty();
        };
    }, []);
    return (react_1.default.createElement(styles_1.OrgChartContainer, __assign({ id: idContainer || 'vx-org-chart-container', ref: containerRef }, { lineWidth: lineWidth, lineColor: lineColor })));
};
exports.VOrgChart = VOrgChart;
